import { render, staticRenderFns } from "./nonAnswerArea.vue?vue&type=template&id=1740a088&scoped=true"
import script from "./nonAnswerArea.vue?vue&type=script&lang=js"
export * from "./nonAnswerArea.vue?vue&type=script&lang=js"
import style0 from "./nonAnswerArea.vue?vue&type=style&index=0&id=1740a088&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1740a088",
  null
  
)

export default component.exports